import React, { useEffect, useState } from "react";
import "./style.css";
import { message } from "antd";
import Lottie from "lottie-react";
import reportGeneration from "../../../Assets/Animations/Report Generation.json";
import { getMileage } from "../../../API/mileage";
import { useDateFilter } from "../../../Contexts/DateFilterContext";
import StackedBarChart from "../../../Components/Charts/StackedBarChart";
import AreaChart from "../../../Components/Charts/AreaChart";
import BarChart from "../../../Components/Charts/BarChart";
import PolarAreaChart from "../../../Components/Charts/PolarAreaChart";

const Mileage = () => {
  const defaultMileageData = {
    mileagevsfuel: { mileage: [], fuel: [], labels: [] },
    fleet: { data: [], labels: [] },
    fleet_mileage_overview: { mileage: [], labels: [] },
    avgvsvehicle: { data: [], labels: [] },
    fuel_consumed: { fuel: [], labels: [] },
    fleet_milage: 0,
    fleet_fuel: 0,
    fleet_total_distance: 0,
    vehicle_average: 0,
    fleet_fuel_consumed: 0,
    fleet_size: 0,
  };

  const [loading, setLoading] = useState(true);
  const [mileageData, setMileageData] = useState(defaultMileageData);
  const { from, to } = useDateFilter();

  useEffect(() => {
    if (!to || !from) {
      // Skip API call if dates are not set
      return;
    }

    const fetchMileageData = async () => {
      try {
        setLoading(true);
        const response = await getMileage(to, from);
        // Merge response.data with defaultMileageData to ensure all properties exist
        setMileageData({
          ...defaultMileageData,
          ...response.data,
          mileagevsfuel: {
            ...defaultMileageData.mileagevsfuel,
            ...(response.data?.mileagevsfuel || {}),
          },
          fleet: {
            ...defaultMileageData.fleet,
            ...(response.data?.fleet || {}),
          },
          fleet_mileage_overview: {
            ...defaultMileageData.fleet_mileage_overview,
            ...(response.data?.fleet_mileage_overview || {}),
          },
          avgvsvehicle: {
            ...defaultMileageData.avgvsvehicle,
            ...(response.data?.avgvsvehicle || {}),
          },
          fuel_consumed: {
            ...defaultMileageData.fuel_consumed,
            ...(response.data?.fuel_consumed || {}),
          },
        });
        setLoading(false);
      } catch (error) {
        message.error("Failed to fetch mileage data");
        console.log(error, "Failed to fetch mileage data");
        setLoading(false);
      }
    };

    fetchMileageData();
  }, [to, from]);

  console.log(mileageData?.fleet_size);
  return (
    <div className="mileage">
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="loader-container"
        >
          <Lottie
            animationData={reportGeneration}
            loop={true}
            style={{ width: 150, height: 150 }}
          />
        </div>
      ) : (
        <div className="rows-container">
          <div className="row tabs">
            <div className="tab-item">
              <div className="left">
                <span className="tab-title">
                  Fleet Vehicle Milage & Fuel Consumption
                </span>
                <div className="row-data">
                  <div className="block">
                    <span className="value-box1">
                      {mileageData?.fleet_milage} Km
                    </span>
                    <span className="value-box1 ">
                      {mileageData?.fleet_fuel} L
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="tab-item">
              <div className="left">
                <span className="tab-title">Fleet Size, Fleet Average</span>
                <div className="row-data">
                  <div className="block">
                    <span className="value-box2">
                      {mileageData?.fleet_size}
                    </span>
                    <span className="value-box2">
                      {mileageData?.vehicle_average} Km
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-item">
              <div className="left">
                <span className="tab-title">Fleet Fuel Consumption</span>
                <div className="row-data">
                  <div className="block">
                    <div className="block">
                      <span className="value-box3">
                        {mileageData?.fleet_fuel_consumed} L
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="graph">
              <StackedBarChart
                graphData={mileageData?.mileagevsfuel || {}}
                lengthKeys={2}
                colourTheme={["#2662D9", "#FB3748"]}
                graphTitle="Vehicles Mileage & Fuel Consumption"
                selectTenByDefault={false}
                units={["Km", "L"]}
                classNameCSS="vehiclemileage-and-fuelconsumpution"
              />
            </div>
            <div className="graph">
              <BarChart
                graphData={{
                  labels: mileageData?.avgvsvehicle?.labels,
                  mileage: mileageData?.avgvsvehicle?.mileage,
                }}
                lengthKeys={1}
                colourTheme={["#FB3748", "#1FC16B"]}
                graphTitle="Fleet Avg VS Vehicle (KM)"
                selectTenByDefault={false}
                units={["Km"]}
                dottedline={mileageData?.vehicle_average?.map((val) => ({
                  value: val,
                  dashArray: 5,
                  width: 2,
                  color: "#94A3B8",
                  label: "Fleet Avg",
                }))}
                classNameCSS="fleet-avg-vs-vehicle"
              />
            </div>
          </div>

          <div className="row">
            <div className="graph">
              <AreaChart
                graphData={mileageData?.fleet_mileage_overview || {}}
                lengthKeys={1}
                colourTheme={["#1FC16B"]}
                graphTitle="Fleet Mileage Overview"
                selectTenByDefault={true}
                units={["Km"]}
                classNameCSS="fleet-mileage"
              />
            </div>
          </div>
          <div className="row">
            <div className="graph">
              <PolarAreaChart
                graphData={{
                  labels: mileageData?.fleet?.labels,
                  distance: mileageData?.fleet?.distance,
                }}
                lengthKeys={1}
                colourTheme={[
                  "#1FC16B",
                  "#FB3748",
                  "#B73AFF",
                  "#FFBE0B",
                  "#2662D9",
                  "#d92691ff",
                ]}
                graphTitle="Fleet"
                selectTenByDefault={false}
                classNameCSS="fleet"
              />
            </div>
            <div className="graph">
              <BarChart
                graphData={mileageData?.fuel_consumed || {}}
                lengthKeys={1}
                colourTheme={["#1FC16B"]}
                graphTitle="Fuel Consumed"
                selectTenByDefault={false}
                units={["L"]}
                classNameCSS="fuel-consumed"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Mileage;
